import axios from 'axios';
import Settings from "../../settings.json";
const url = Settings.isNative ? Settings.frontlineArServer : "";

export class SurveyRequester {

    static async createQuestion(db, surveyType, questionText, questionType, options = []) {
        const result = await axios.post(`${url}/survey/questions/create/${db}`, {
            surveyType,
            questionText,
            questionType,
            options
        });
        return result.data;
    }

    static async getQuestion(db, surveyType, questionId) {
        const result = await axios.post(`${url}/survey/questions/get/${db}/${surveyType}/${questionId}`);
        return result.data;
    }

    static async listQuestions(db, surveyType, surveyIdentifier = null,includeInactive = false) {
        const result = await axios.post(`${url}/survey/questions/list/${db}/${surveyType}`, {
             includeInactive, surveyIdentifier
        });
        return result.data;
    }

    static async updateQuestion(db, surveyType, questionId, data) {
        // data: { questionText, questionType, options, isActive }
        const result = await axios.put(`${url}/survey/questions/update/${db}/${surveyType}/${questionId}`, data);
        return result.data;
    }

    static async deleteQuestion(db, surveyType, questionId) {
        const result = await axios.delete(`${url}/survey/questions/delete/${db}/${surveyType}/${questionId}`);
        return result.data;
    }

    static async reorderQuestions(db, surveyType, orderedQuestionIds) {
        const result = await axios.put(`${url}/survey/questions/reorder/${db}/${surveyType}`, {
            orderedQuestionIds
        });
        return result.data;
    }

    static async submitAnswer(db, surveyType, surveyResponse) {
        const result = await axios.post(`${url}/survey/answer/${db}/${surveyType}`, {
            surveyResponse
        });
        return result.data;
    }

    static async checkAnswerExists(db, surveyType, surveyResponse) {
        const result = await axios.post(`${url}/survey/checkIfAlreadyAnswered/${db}/${surveyType}`, {
            surveyResponse
        });
        return result.data;
    }

    static async getAnalytics(db, surveyType, dateRange) {
        const result = await axios.post(`${url}/survey/analytics/${db}/${surveyType}`, {
            dateRange
        });
        return result.data;
    }

    static async getTextAnswerPagination(db, surveyType, questionId, dateRange, skip, limit) {
        const result = await axios.post(`${url}/survey/textAnswerPagination/${db}/${surveyType}`, {
            questionId,
            dateRange,
            skip,
            limit
        });
        return result.data;
    }
}
